<template>
  <!-- HEADER -->
  <div class="header">
    <div class="container-fluid">
      <!-- Table -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Role Menu Management</h4>
        </div>
        <vue-good-table
          :line-numbers="true"
          :columns="columns"
          :rows="list"
          :sort-options="{
            enabled: false
          }"
          :total-rows="10"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            position: 'bottom',
            perPage: 10,
            perPageDropdown: [10, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All'
          }"
          style-class="vgt-table border-0 table"
          @on-page-change="onPageChange"
          @on-per-page-change="onPageChange">
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            No data available
          </div>

          <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- Table Action -->
            <span v-if="props.column.field == 'action'">
              <b-button
                v-if="listTabMenu?.privilages?.update"
                class="no-wrap btn-pill"
                variant="warning"
                size="sm"
                @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
            </span>
          </template>
        </vue-good-table>
      </div>

      <!-- Modal -->
      <b-modal
        id="modal-1"
        centered
        hide-footer
        title="Edit Role Menu"
        size="lg">
        <form @submit.prevent="saveUpdate()">
          <div class="form-group">
            <label>Role Name</label>
            <input
              v-validate="'required'"
              name="Role Name"
              type="text"
              v-model="bodyUpdate.roles_name"
              class="form-control"
              placeholder="Role Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Role Name')"
              >{{ errors.first("Role Name") }}</span
            >
          </div>
          <div class="form-group">
            <div class="list">
              <div v-for="(item, index) in listRoleMenuCopy" :key="index"> 
                <!-- Menu Utama -->
                <div class="">
                  <hr/>
                  <div class="form-check">
                    <div class="row align-items-center">
                      <div class="col-lg-4 col-12">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'menu-' + index" 
                          v-model="item.privilage.read"
                        >
                        <label class="form-check-label" :for="'menu-' + index"><b>{{ item.title }}</b></label>
                      </div>

                      <div class="col-lg-2 col-12" v-if="item.children.length === 0">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'read-' + index" 
                          v-model="item.privilage.read"
                        >
                        <label class="form-check-label" :for="'read-' + index">Read</label>
                      </div>

                      <div class="col-lg-2 col-12" v-if="item.children.length === 0">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'create-' + index" 
                          v-model="item.privilage.create"
                        >
                        <label class="form-check-label" :for="'create-' + index">Create</label>
                      </div>

                      <div class="col-lg-2 col-12" v-if="item.children.length === 0">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'update-' + index" 
                          v-model="item.privilage.update"
                        >
                        <label class="form-check-label" :for="'update-' + index">Update</label>
                      </div>

                      <div class="col-lg-2 col-12" v-if="item.children.length === 0">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'delete-' + index" 
                          v-model="item.privilage.delete"
                        >
                        <label class="form-check-label" :for="'delete-' + index">Delete</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Sub-menu -->
                <div class=" ml-4" v-for="(sub, subIdx) in item.children" :key="subIdx">
                  <hr/>
                  <div class="form-check">
                    <div class="row align-items-center">
                      <div class="col-lg-4 col-12">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'menu-' + index + '-sub-' + subIdx" 
                          v-model="sub.privilage.read"
                        >
                        <label class="form-check-label" :for="'menu-' + index + '-sub-' + subIdx">
                          {{ sub.title }}
                        </label>
                      </div>

                      <div class="col-lg-2 col-12">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'read-' + index + '-sub-' + subIdx" 
                          v-model="sub.privilage.read"
                        >
                        <label class="form-check-label" :for="'read-' + index + '-sub-' + subIdx">Read</label>
                      </div>

                      <div class="col-lg-2 col-12">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'create-' + index + '-sub-' + subIdx" 
                          v-model="sub.privilage.create"
                        >
                        <label class="form-check-label" :for="'create-' + index + '-sub-' + subIdx">Create</label>
                      </div>

                      <div class="col-lg-2 col-12">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'update-' + index + '-sub-' + subIdx" 
                          v-model="sub.privilage.update"
                        >
                        <label class="form-check-label" :for="'update-' + index + '-sub-' + subIdx">Update</label>
                      </div>

                      <div class="col-lg-2 col-12">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          :id="'delete-' + index + '-sub-' + subIdx" 
                          v-model="sub.privilage.delete"
                        >
                        <label class="form-check-label" :for="'delete-' + index + '-sub-' + subIdx">Delete</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false">
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"></span>
              Loading...
            </button>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>
<script>
export default {
  name: "trainingType",
  computed: {
    list() {
      return this.$store.getters["role/roleManagement"];
    },
    listRoleMenu() {
      return this.$store.getters["role/roleMenu"];
    },
  },
  data() {
    return {
      body: {
        page: 1,
        limit: 10
        // order: "",
        // search: "",
      },
      listTabMenu: {},
      listRoleMenuCopy: [],
      bodyAdd: {
        roles_name: "",
        description: ""
      },
      bodyUpdate: {
        id: "",
        menu: "",
        roles_name: "",
        description: ""
      },
      isAdd: true,
      isLoading: false,
      openItems: {},
      data_update: {},
      columns: [
        {
          label: "id",
          field: "id",
          thClass: "table-header text-muted w-50 font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        {
          label: "Name",
          field: "name",
          thClass: "table-header text-muted w-50 font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        {
          label: "ACTION",
          field: "action",
          thClass: "table-header no-wrap text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
          sortable: false
        }
      ]
    };
  },
  mounted() {
    this.getList();
    this.getListRole();
    const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find((menu) =>
      menu.link === currentPath || menu.children.find((child) => child.link === currentPath)
    );
    this.listTabMenu = menu.children.find((item) => item.link === currentPath);
  },
  methods: {
    toggleItem(menuId) {
      this.$set(this.openItems, menuId, !this.openItems[menuId]);
    },
    isOpen(menuId) {
      return !!this.openItems[menuId];
    },
    updateMenuSelection(item) {
      if (item.check) {
        if (!this.bodyUpdate.menu.includes(item.menuId)) {
          this.bodyUpdate.menu.push(item.menuId);
        }
      } else {
        this.bodyUpdate.menu = this.bodyUpdate.menu.filter(
          (id) => id !== item.menuId
        );
      }

      if (item.children) {
        item.children.forEach((child) => {
          child.check = item.check;
          if (item.check) {
            if (!this.bodyUpdate.menu.includes(child.menuId)) {
              this.bodyUpdate.menu.push(child.menuId);
            }
          } else {
            this.bodyUpdate.menu = this.bodyUpdate.menu.filter(
              (id) => id !== child.menuId
            );
          }
        });
      }
    },
    //action
    updateData(props) {
      console.log(props);
      this.data_update = props
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.roles_name = props.name;
      // Buat salinan listRoleMenu agar tidak mengubah computed property langsung
      // let updatedMenu = this.listRoleMenu.map(menu => {
      //   let isChecked = props.menus.includes(parseInt(menu.id));
      //   let privilegeData = props.privileges.find(p => p.id === parseInt(menu.id));
      //   menu.privilages = privilegeData
      //     ? { ...privilegeData.privilage }
      //     : { read: false, create: false, update: false, delete: false };
      //   menu.check = isChecked;
      //   if (menu.children && menu.children.length > 0) {
      //     menu.children = menu.children.map(sub => {
      //       let subChecked = props.menus.includes(parseInt(sub.id));
      //       let subPrivilege = props.privileges.find(p => p.id === parseInt(sub.id));
      //       sub.privilages = subPrivilege
      //       ? { ...subPrivilege.privilage }
      //       : { read: false, create: false, update: false, delete: false };
      //       sub.check = subChecked;
      //       return sub;
      //     });
      //   }
      //   return menu;
      // });
      // // Simpan ke data, bukan ke computed property
      // this.listRoleMenuCopy = updatedMenu;
      this.$store.dispatch("role/getRoleByID", props.id).then(() => {
        let data = this.$store.getters["role/roleByID"];
        this.listRoleMenuCopy = data;
        this.$bvModal.show("modal-1");
        this.isAdd = false;
      });
    },
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        try {
          this.isLoading = true;
          this.$store.dispatch("role/addRole", this.bodyAdd).then((resp) => {
            this.$swal({
              title: "Tersimpan",
              text: "Data berhasil disimpan",
              icon: "success",
              confirmButtonText: "OK"
            }).then((resp) => {
              this.isLoading = false;
              this.role_name = "";
              this.getList();
              this.$bvModal.hide("modal-1");
            });
          });
        } catch (resp) {
          this.$swal("Error", "Gagal menambah data", "error");
        }
      });
    },

    saveUpdate() {
      const data = {
        id: this.bodyUpdate.id,
        requestData: { datas: this.listRoleMenuCopy}
      };
      this.isLoading = true;
      this.$store
        .dispatch("role/updateRole", data)
        .then((resp) => {
          this.$swal({
            title: "Tersimpan",
            text: "Data berhasil disimpan",
            icon: "success",
            confirmButtonText: "OK"
          }).then((resp) => {
            this.isLoading = false;
            this.getList();
            this.$bvModal.hide("modal-1");
          });
        })
        .catch((resp) => {
          this.isLoading = false;
          this.$swal("Error", resp.response.data.error, "error");
        });
    },
    deleteData(id) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.$store
            .dispatch("role/delRole", id)
            .then((resp) => {
              this.isLoading = false;
              this.getList();
              this.$swal("Terhapus", "Data berhasil dihapus", "success");
            })
            .catch((resp) => {
              this.$swal("Error", "Gagal menghapus data", "error");
            });
        }
      });
    },

    // api hit
    getList() {
      this.$store.dispatch("role/getRole");
    },
    getListRole() {
      this.$store.dispatch("role/getRoleMenu");
    },

    sorting() {
      this.getList();
      this.body.page = 1;
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getList();
    }
  }
};
</script>
<style>
.list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.list-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px;
  margin: 5px 0;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.list-item:hover {
  background-color: #f1f1f1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.list-item input[type="checkbox"] {
  margin-right: 10px;
}

.list-item span {
  /* flex-grow: 1; */
  font-family: "Arial", sans-serif;
  font-size: 16px;
  color: #333;
}
</style>
